<template>
  <custom-dialog class="enter-logistics-no-dialog" width="448px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form ref="form" size="mini" :rules="rules" :model="form">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('components_enterLogisticsNoDialog.wu_liu_gong_si')" prop="companyCode">
              <custom-select ref="company" filterable v-model="form.companyCode" code="ice_logistics_company" :placeholder="$t('Common.com_please_select')" width="100%" @change="onChange"></custom-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!form.companyCode">
          <el-col :span="24">
            <el-form-item :label="$t('components_enterLogisticsNoDialog.qi_ta_wu_liu')" prop="companyName">
              <el-input v-model="form.companyName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('components_enterLogisticsNoDialog.wu_liu_dan_hao')" prop="orderNo">
              <el-input v-model="form.orderNo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
/**
 * 录入物流单号
 * 事件：confirm | success。当传入contractDeliveryId时，事件为success;否则为confirm。事件参数：data
 * data.companyCode : 公司编码; 与data.other 互斥
 * data.companyName : 公司名称；当data.companyCode存在时，该字段存在
 * data.other : 其他公司； 与data.companyCode互斥
 * data.orderNo : 物流单号；
 */
import apis from '@/utils/apis';

export default {
  props: {
    // 传入表单的数据 model.companyCode : 物流公司编码 model.orderNo : 物流单号 model.other: 其他物流公司
    model: {
      type: Object,
      default() {
        return {};
      },
    },
    // 非必填，传入该参数时，会执行提交到服务端
    contractDeliveryId: [String, Number],
  },
  mounted: function () {
    this.rules.companyName.message = this.$t('components_enterLogisticsNoDialog.cdzc100gzf');
    this.rules.orderNo[0].message = this.$t('components_enterLogisticsNoDialog.cdzc50gzf');
    this.init();
  },
  data() {
    return {
      visible: true,
      form: {
        companyName: '',
        companyCode: '',
        orderNo: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        companyName: {
          max: 100,
          message: this.$t('Common.com_rules_length_max', [100]),
          type: 'string',
        },
        orderNo: [{ max: 50, message: this.$t('Common.com_rules_length_max', [50]), type: 'string' }],
      };
    },
  },
  methods: {
    clearValidate() {
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    initData() {
      this.form.companyName = this.model.companyName || '';
      this.form.companyCode = this.model.companyCode || '';
      this.form.orderNo = this.model.orderNo || '';
    },
    init() {
      this.initData();
      this.clearValidate();
    },
    onConfirm() {
      this.$refs.form.validate((val) => {
        if (val) {
          if (this.contractDeliveryId) {
            this.$postJSON(apis.LogisticsUpdate, this.getReqData()).then(() => {
              this.visible = false;
              this.$emit('success', this.form);
            });
          } else {
            this.visible = false;
            this.$emit('confirm', this.form);
          }
        }
      });
    },
    onChange: function (row) {
      this.form.companyName = row.value ? row.name : '';
    },
    getReqData() {
      const ret = {
        contractDeliveryId: this.contractDeliveryId,
        logisticsCompanyCode: this.form.companyCode,
        logisticsCompanyName: this.form.companyName,
        shipmentNum: this.form.orderNo,
      };
      return ret;
    },
  },
};
</script>

<style lang="scss">
.enter-logistics-no-dialog {
  .el-form-item__label {
    text-align: left;
    width: 100% !important;
  }
}
</style>
